const getTrackingInfo = (state) => {
  return state
}

export default {
  getTrackingInfo
}



// WEBPACK FOOTER //
// ./src/store/modules/user/tracking/getters.js